import { errorToast, successToast } from "@idwal/idwal-react-components";
import axios from "axios";
import { getTranslationObject } from "./Translation";
import { getCurrentUserName } from "../queries/authToken";

const t = getTranslationObject();

export const updateOptIn = (InspectionId: string, CustomerOptIn: string, user: any) => {
    const url = process.env.REACT_APP_IDWAL_API_URL + "/Inspection/DataOptIn";
    const token = user.signInUserSession.idToken.jwtToken;

    axios.post(url, {
            InspectionId,
            CustomerOptIn
        },
    {
        headers: {
            "Authorization": "Bearer " +  token
        }
    }).then(result => {
        return result.data
    });
}

export const sharePublicInspection = (inspectionId: string, email: string, user: any) => {
    if (!email) {
        errorToast("Please enter an email address to share the inspection with");
        return;
    }

    const url = process.env.REACT_APP_IDWAL_API_URL + `/Inspection/${inspectionId}/publicShare`;
    const token = user.signInUserSession.idToken.jwtToken;

    axios.post(url, {
            email,
            requestingUserId: user.username
        },
    {
        headers: {
            "Authorization": "Bearer " +  token
        }
    }).then(result => {
        successToast(t("documents.shareReport.success"))
        return result.data
    }).catch(() => {
        errorToast(t("documents.shareReport.error"));
    });
}

export const sharePublicInspectionWithNameAndOrg = async (
    name: string, 
    customerOrganization: string, 
    inspectionOrganization: string,
    email: string, 
    inspectionId: string, 
    user: any,
    inspectionDetails: {
        vessel: string,
        inspectionNumber: string,
        inspectionType: string
    }
) => {
    if (!email) {
        errorToast("Please enter an email address to share the inspection with");
        return;
    }

    const url = process.env.REACT_APP_IDWAL_API_URL + `/Inspection/${inspectionId}/share-report`;
    const token = user.signInUserSession.idToken.jwtToken;

    const username = await getCurrentUserName()

    axios.post(url, {
        event: "INSPECTION_SHARE_REPORT",
        context: `INSPECTION-${inspectionId}`,
        inspectionId,
        email,
        inspectionOrganization,
        customerOrganization,
        name,
        timestamp: Math.floor(Date.now() / 1000),
        triggered_by: user.username,
        activity: "report_shared",
        vessel: inspectionDetails.vessel,
        inspectionNumber: inspectionDetails.inspectionNumber,
        reportType: inspectionDetails.inspectionType,
        sharedByName: username
    },
    {
        headers: {
            "Authorization": "Bearer " +  token
        }
    }).then(result => {
        successToast(t("documents.shareReport.success"))
        return result.data
    }).catch((err) => {
        console.error(err);
        errorToast(t("documents.shareReport.error"));
    });
}

export const axiosGet = async (url: string) => {

    if (!url) {
        throw new Error("No inspection type url configured");
    }

    try {
        const result = await axios.get(url);

        if (!result.data) {
            throw new Error("No data");
        }

        return Promise.resolve(result.data);
    } catch(e: any) {
        throw new Error(e);
    }
}
